import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { getUserList } from "../../../redux/invoice/action";
import { getMembershipList } from "../../../redux/membership/action";
import { customerMembershipValidation } from "../../Constant/constant";
import { addCustomerMembershipData } from "../../../redux/cutomerMemb/action";

const AddCustomermembership = () => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsMember, setSelectedOptionsMember] = useState([]);
  const [startDates, setStartDates] = useState("");
  const [params, setParams] = useState({
    search_key: "",
  });
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userList = useSelector((state) => state?.reusableSlice?.userList);
  const membershipList = useSelector(
    (state) => state?.reusableSlice?.membershipList
  );

  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.full_name,
  }));
  const proMembOptions = membershipList?.memberships?.map((item) => ({
    value: item?.id,
    label: `${item?.title} (${
      item?.display_duration_label ||
      (item?.duration_type === 1 ? "Monthly" : "Semi-Annual")
    })`,
  }));

  useEffect(() => {
    dispatch(getUserList(params));
  }, [dispatch, params]);

  useEffect(() => {
    dispatch(getMembershipList(params));
  }, [dispatch, params]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    formik.setFieldValue("user_id", selected?.value);
  };

  const handleChangeMember = (selected) => {
    setSelectedOptionsMember(selected);
    formik.setFieldValue("membership_id", selected?.value);
  };

  const handleStartDateChange = (event) => {
    setStartDates(event.target.value);
    formik.setFieldValue("start_date", event.target.value);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      user_id: "",
      membership_id: "",
      start_date: "",
      end_date: "",
      max_invoices: "",
      used_invoices: "",
    },
    validationSchema: customerMembershipValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    dispatch(addCustomerMembershipData(data, setLoading, navigate));
  };

  return (
    <div className="p-3">
      <div className=" category-wrapper">
        <h3 className="pb-3">Create Customer Membership</h3>
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-md-4 form-group">
              <label>Select Customer</label>
              <ReactSelect
                value={selectedOptions}
                onChange={handleChange}
                options={proOptions}
                placeholder="select customer"
              />
              {formik.touched.user_id && formik.errors.user_id ? (
                <div className="error">{formik.errors.user_id}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Select Membership</label>
              <ReactSelect
                value={selectedOptionsMember}
                onChange={handleChangeMember}
                options={proMembOptions}
                placeholder="select membership"
              />
              {formik.touched.membership_id && formik.errors.membership_id ? (
                <div className="error">{formik.errors.membership_id}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Start Date</label>
              <input
                type="date"
                className="form-control w-100"
                placeholder="Enter start date"
                value={startDates}
                onChange={handleStartDateChange}
                onBlur={formik.handleBlur}
                name="start_date"
              />
              {formik.touched.start_date && formik.errors.start_date ? (
                <div className="error">{formik.errors.start_date}</div>
              ) : null}
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn  "
              type="button"
              disabled={loading}
              onClick={() => {
                navigate(-1);
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
              disabled={loading}
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCustomermembership;
